import { SVGProps, Ref, forwardRef } from 'react';

export const DotFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path d="M12 10c-1.5 0-2 1-2 2s.5 2 2 2 2-1 2-2-.5-2-2-2" fill="currentColor" />
    </svg>
));
DotFilledSize24Glyph.displayName = 'DotFilledSize24Glyph';
